<script>
    export let DEBUG;

    export let values = {};
    export let frozenValues = {};

    let risk;
    let frozenRisk;

    function calculateFullyEdentulousRisk(values) {
        return 0.12125
            + 0.73327 * values.systemic
            + 2.33094 * (values.location === "upper")
            - 0.21962 * values.smoking
            - 0.01214 * values.recall
            - 7.70891 * (values.systemic && (values.location === "upper"));
    }

    function convertRiskToPercentage(risk) {
        return Math.round(Math.exp(risk) / (1 + Math.exp(risk)) * 100);
    }

    function calculatePartiallyEdentulousRisk(values) {
        return   0.89136
        + 0.48400 * (values.bone_loss / values.age) // -0.24200
        + 0.00624 * values.fmbs                     // -0.00624
        + 1.35786 * values.systemic                 // -1.35786
        - 0.17000 * (values.location === "upper")   // - 0.72951
        + 0.05293 * values.ppd                      // number of teeth
        + 0.01847 * values.teeth_lost
        + 0.03342 * values.smoking
        + 0.02283 * values.recall                   // -0.02283
        // + 1.4075  * (values.systemic && (values.location === "upper"));

        // return 0.24576
        //     - 0.00536 * (values.bone_loss / values.age)
        //     + 0.00613 * values.fmbs
        //     - 1.46271 * values.systemic
        //     - 0.66802 * (values.location === "upper")
        //     + 0.05149 * values.ppd
        //     + 0.01418 * values.teeth_lost
        //     + 0.03404 * values.smoking
        //     + 0.02440 * values.recall   // - 0.00488
        //     + 1.51938 * (values.systemic && (values.location === "upper"));
    }

    $: if (values.edentulism === true) {
        risk = calculateFullyEdentulousRisk(values);
        frozenRisk = calculateFullyEdentulousRisk(frozenValues);
    } else {
        risk = calculatePartiallyEdentulousRisk(values);
        frozenRisk = calculatePartiallyEdentulousRisk(frozenValues);
    }

    $: riskPercentage = convertRiskToPercentage(risk);
    $: frozenRiskPercentage = convertRiskToPercentage(frozenRisk);
</script>

<svg xmlns="http://www.w3.org/2000/svg"
     width="100%" height="100%" viewBox="65,0,40,15">
    <defs>
        <linearGradient id="Gradient1">
            <stop offset="10%" stop-color="#d1eaa3" />
            <stop offset="40%" stop-color="#fafcc2" />
            <stop offset="60%" stop-color="#fafcc2" />
            <stop offset="80%" stop-color="#fed2a0" />
        </linearGradient>
    </defs>

    <rect id="rect1" x="65" y="0" rx="3" ry="3" width="40" height="15" />

    {#if (!isNaN(frozenRisk))}
        <path
              d="M{frozenRiskPercentage-2.5},2.5 L {frozenRiskPercentage} 5, {frozenRiskPercentage+2.5} 2.5"
              fill="none" stroke="rgba(0,0,0,0.5)" stroke-width="1" stroke-linecap="round"></path>

        {#if (risk !== frozenRisk)}
        <path
              d="M{riskPercentage-2.5},12.5 L {riskPercentage} 10, {riskPercentage+2.5} 12.5"
              fill="none" stroke="rgba(0,0,0,0.2)" stroke-width="1" stroke-linecap="round"></path>
        {/if}
    {/if}
</svg>

{#if (DEBUG)}
<pre style="font-size: 7pt">{#if (values.edentulism)}Fully:
Outcome =
0.03997
    + 1.04007 * General health (Yes): {values.systemic}
    + 2.65221 * Location (Upper jaw): {values.location === "upper"}
    - 0.23162 * Smoking [cigs/day]: {values.smoking}
    - 0.004   * Recall [mts]: {values.recall}
    - 8.18198 * (
	General health (Yes): {values.systemic}
    AND
	Location (Upper jaw): {values.location === "upper"}
    ) = { 0.03997
+ 1.04007 * values.systemic
+ 2.65221 * (values.location === "upper")
- 0.23162 * values.smoking
- 0.004   * values.recall
- 8.18198 * (values.systemic && (values.location === "upper"))}

Risk = { riskPercentage }{:else if (values.edentulism === false)}Partial:
Outcome =
0.89136
+ 0.48400 * Susceptibility [%]: {values.bone_loss / values.age}
+ 0.00624 * FMBS [%]: {values.fmbs}
+ 1.35786 * General health (Yes): {values.systemic}
- 0.17000 * Location (Upper jaw): {values.location === "upper"}
+ 0.05293 * # PPD >= 5mm: {values.ppd}
+ 0.01847 * # teeth lost: {values.teeth_lost}
+ 0.03342 * Smoking [cigs/day]: {values.smoking}
+ 0.02283 * Recall [months]: {values.recall}
= {risk}

Risk = { riskPercentage }{:else}Model cannot be computed.{/if}
</pre>
{/if}

<style>
    #rect1 { fill: url(#Gradient1); }

    #risk-info {
        margin: 2em 0;
    }

    #risk-info h2 {
        font-size: 120%
    }
</style>